import React, { useState, useEffect } from 'react';
import './styles.scss';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import AddCircle from '@material-ui/icons/AddCircle';
import MaterialTable from '@material-table/core';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AccordionActions from '@material-ui/core/AccordionActions';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import IconButton from '@material-ui/core/IconButton';
import { NotificationManager } from 'react-notifications';
import { MdUndo, MdSearch } from "react-icons/md";
import { DatePicker } from "@material-ui/pickers";
import { Link, useHistory } from "react-router-dom";
import moment from 'moment';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function MainComponent(props) {

    let history = useHistory();
    const Editbutton = (ID) => {
        history.push("/PlanTemplate/Edit/" + ID);
    }
    const DeleteButton = (ID) => {  
        const Datadelete = {
        "ID": ID
        };
        props.DeleteTemplate(Datadelete);
        window.location.reload();
        const DataSearch = {
            "name": "All",
            "createBy": "admin",
            "createDate": new Date(),
            "ToDate": new Date(),
            "Status": 0
        };
        props.GetDataMain(DataSearch);


    }
    const Newbutton = () => {
        history.push("/PlanTemplate/New");
    }
    const state = {
        columns: [
            { title: 'Tên Loại KH', width: 300, field: 'name', filtering: false, editable: 'never', render: rowData => <Link to={"/PlanTemplate/Edit/" + rowData.id} >{rowData.name}</Link> },
            { title: 'Số Bước', width: 150, field: 'stepNumber', filtering: false, editable: 'never' },
            {
                title: 'Ngày tạo', width: 162, field: 'createDate', filtering: false, editable: 'never', type: 'date', dateSetting: {
                    format: 'dd/MM/yyyy hh:mm:ss'
                },
            },
            { title: 'Người tạo', width: 300, field: 'email', filtering: false, editable: 'never' },
            { title: 'Người tạo', width: 300, field: 'createBy', filtering: false, editable: 'never', hidden: true },
            { title: 'Thao tác', width: 200, field: 'PlanID', render: rowData => <div><IconButton className="editicon" onClick={() => Editbutton(rowData.id)} ><EditIcon /></IconButton><IconButton className="deleteicon" onClick={() => DeleteButton(rowData.id)} ><DeleteOutlineIcon /></IconButton> </div>, filtering: false, editable: 'never' },
        ]
    };

    var curr = new Date();
    curr.setDate(curr.getDate());
    // eslint-disable-next-line
    const [expanded, setExpanded] = useState('panel1');
    const [selectedFromDate, setFromDateChange] = useState(new Date(moment().subtract(7,'d').format('YYYY-MM-DD')));
    const [selectedToDate, setToDateChange] = useState(new Date());
    const [LoaiKH, SetLoaiKH] = useState("");
    const [Asigner, SetAsigner] = useState();
    const [Status, SetStatus] = useState();
    // eslint-disable-next-line
    const [valueStatus, setValueStatus] = useState([
        { title: 'Tất cả', value: 0 },
        { title: 'Active', value: 1 },
        { title: 'DeActive', value: 2 }
    ]);

    // eslint-disable-next-line
    const [valueasigner, setvalueasigner] = useState([
        { title: 'Tất cả', value: 0 },
        { title: "TrongNM3@fpt.com", value: 1 },
        { title: "NgoanHT@fpt.com", value: 2 }
    ]);

    const date1 = Date.now();
    var todaynull = new Intl.DateTimeFormat('en-US').format(date1);
    if (selectedFromDate === "") {
        setFromDateChange(todaynull);
        setToDateChange(todaynull);
    }
    const handleFromDateChange = (event) => {
        setFromDateChange(event);
    };
    const handleToDateChange = (event) => {
        setToDateChange(event);
    };

    useEffect(() => {
        const DataSearch = {
            "name": "All",//LoaiKH,
            "createBy": "admin",
            "createDate": new Date(),
            "ToDate": new Date(),
            "Status": 0//status
        };
        const DataKH = {
            "Type": "2",
        };
        props.GetDataMain(DataSearch);
        props.GetDataKHName(DataKH);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.isResult) {
            const DataSearch = {
                "name": "All",//LoaiKH,
                "createBy": "admin",
                "createDate": new Date(),
                "ToDate": new Date(),
                "Status": 0//status
            };
            props.GetDataMain(DataSearch);
        }
        // eslint-disable-next-line
    }, [props.isResult])

    const fn_SetStatus = (newValue, reason) => {
        if (reason === "select-option") {
            if (newValue.some(x => x.value === 0) || (!newValue.some(x => x.value === 0) && newValue.length === valueStatus.length - 1)) {
                SetStatus(valueStatus);
            }
            else {
                SetStatus(newValue);
            }
        }
        else if (reason === "remove-option") {
            if (newValue.some(x => x.value === 0)) {
                var index = newValue.findIndex(x => x.value === 0);
                SetStatus([...newValue.slice(0, index),
                ...newValue.slice(index + 1)]);
            }
            else if (!newValue.some(x => x.value === 0) && newValue.length === valueStatus.length - 1) {
                SetStatus();
            }
            else {
                SetStatus(newValue);
            }
        }
        else if (reason === "clear") {
            SetStatus();
        }
    }

    const fn_SetAsigner = (newValue, reason) => {
        if (reason === "select-option") {
            if (newValue.some(x => x.value === 0) || (!newValue.some(x => x.value === 0) && newValue.length === valueasigner.length - 1)) {
                SetAsigner(valueasigner);
            }
            else {
                SetAsigner(newValue);
            }
        }
        else if (reason === "remove-option") {
            if (newValue.some(x => x.value === 0)) {
                var index = newValue.findIndex(x => x.value === 0);
                SetAsigner([...newValue.slice(0, index),
                ...newValue.slice(index + 1)]);
            }
            else if (!newValue.some(x => x.value === 0) && newValue.length === valueasigner.length - 1) {
                SetAsigner();
            }
            else {
                SetAsigner(newValue);
            }
        }
        else if (reason === "clear") {
            SetAsigner();
        }
    }
    const fn_search = () => {
        if (selectedFromDate && selectedToDate) {
            const lStatus = [];
            if (Status) {
                // eslint-disable-next-line
                Status.map((item) => {
                    lStatus.push(item.value)
                })
            }
            let name = "";
            if (LoaiKH) {
                name =  LoaiKH.name;
            }
            else {
                name = "All"
            }
            const DataSearch = {
                //"Status": lStatus,
                "name": name,
                "createBy": "admin",//valueasigner.title ? valueasigner.title : "admin",
                "createDate": selectedFromDate,
                "ToDate": selectedToDate,
                "Status": 0//status
            };
            props.GetDataMain(DataSearch);
        }
        else {
            NotificationManager.error("Vui lòng chọn thông tin ngày");
        }
    }
    const fn_reset = () => {
        SetLoaiKH();
        SetAsigner();
        SetStatus();
        setFromDateChange(new Date(moment().subtract(7,'d').format('YYYY-MM-DD')));
        setToDateChange(new Date());
    }
    const fn_SetLoaiKH = (newValue) => {
        SetLoaiKH(newValue);
    }
    if (!props.DataMain) {
        return        <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} >                
        <CircularProgress className="CircularProgress" disableShrink />
            </div>
    }
    else {
        return (
            <div className="Bodyui">
                <div className="header-bodyui">
                    <b className="ml-3" style={{ fontSize: 20 }}>Thiết lập kế hoạch</b>
                    <div className="row buttonadd">
                        <div className="col-md-2">
                            <Button
                                variant="contained"
                                color="secondary"
                                className={"add-new-button btn"}
                                startIcon={<AddCircle />}
                                onClick={Newbutton}
                                style={{border: '2px solid', height: '50px', width: '160px'}}
                            >
                                Thêm mới
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="PlanTemplate_body">
                    <Accordion className="PlanTemplate_002" expanded={expanded === 'panel1'} >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1bh-content"
                            id="panel1bh-header"
                        >
                            <Typography className={"abc"}>Bộ lọc</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div className="col-md-6 PlanTemplate_0014">
                                <Autocomplete
                                    id="combo-box"
                                    disableCloseOnSelect
                                    options={props.DataKHName ? props.DataKHName : []}
                                    size="small"
                                    getOptionLabel={(option) => option.name}
                                    style={{ width: "100%"}}
                                    renderInput={(params) => <TextField {...params} InputLabelProps={{
                                        shrink: true,
                                    }} margin="dense" label="Loại KH" variant="outlined" />}
                                    renderOption={(option) =>
                                        <Typography noWrap style={{ fontSize: "13px", border: '1px solid #fff' }}>{option.name}</Typography>}
                                    className="PlanTemplate_0013"
                                    onChange={(e, newValue) => fn_SetLoaiKH(newValue)}
                                    value={LoaiKH ? LoaiKH : null}
                                    inputProps={{ style: { fontFamily: 'nunito', color: 'white !important'}}}
                                />
                            </div>
                            <div className="col-md-6 PlanTemplate_0014">
                                <Autocomplete
                                    multiple
                                    disableCloseOnSelect
                                    id="combo-box"
                                    limitTags={5}
                                    options={valueasigner}
                                    renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            <Typography noWrap style={{ fontSize: "13px" }}>{option.title}</Typography>
                                        </React.Fragment>
                                    )}
                                    size="small"
                                    getOptionLabel={(option) => option.title}
                                    style={{ width: "100%" }}
                                    renderInput={(params) => <TextField {...params} InputLabelProps={{
                                        shrink: true,
                                    }} margin="dense" label="Người tạo" variant="outlined" />}
                                    className="PlanTemplate_0013"
                                    value={Asigner ? Asigner : []}
                                    onChange={(event, newValue, reason) => fn_SetAsigner(newValue, reason)}
                                />
                            </div>
                            <div className="col-md-6 PlanTemplate_0014">
                                <Autocomplete
                                    multiple
                                    id="combo-box"
                                    limitTags={5}
                                    options={valueStatus}
                                    disableCloseOnSelect
                                    renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                            <Checkbox
                                                icon={icon}
                                                checkedIcon={checkedIcon}
                                                style={{ marginRight: 8 }}
                                                checked={selected}
                                            />
                                            <Typography noWrap style={{ fontSize: "13px" }}>{option.title}</Typography>
                                        </React.Fragment>
                                    )}
                                    size="small"
                                    getOptionLabel={(option) => option.title}
                                    style={{ width: "100%" }}
                                    renderInput={(params) => <TextField {...params} InputLabelProps={{
                                        shrink: true,
                                    }} margin="dense" label="Trạng thái" variant="outlined" />}
                                    className="PlanTemplate_0013"
                                    value={Status ? Status : []}
                                    onChange={(event, newValue, reason) => fn_SetStatus(newValue, reason)}
                                />
                            </div>
                            <div className="col-md-6 PlanTemplate_0014 PlanTemplate_0015">
                                <DatePicker
                                    className="PlanTemplate_0013"
                                    fullWidth
                                    animateYearScrolling
                                    format="dd/MM/yyyy"
                                    label="Từ ngày"
                                    inputVariant="outlined"
                                    margin="dense"
                                    value={selectedFromDate}
                                    onChange={handleFromDateChange}
                                />
                                <div className="clsNg"><span> ~ </span></div>
                                <DatePicker
                                    className="PlanTemplate_0013"
                                    fullWidth
                                    animateYearScrolling
                                    format="dd/MM/yyyy"
                                    label="Đến ngày"
                                    inputVariant="outlined"
                                    margin="dense"
                                    value={selectedToDate}
                                    onChange={handleToDateChange}
                                />
                            </div>
                        </AccordionDetails>
                        <AccordionActions className="PlanTemplate_btnAction">

                            <Button onClick={fn_search} className="PlanTemplate_0021" size="small" startIcon={<MdSearch />} variant="contained" color="primary">Tìm kiếm</Button>
                            <Button onClick={fn_reset} className="PlanTemplate_0022" size="small" startIcon={<MdUndo />} variant="contained" color="primary">Làm mới</Button>

                        </AccordionActions>
                    </Accordion>

                </div>
                <div className="tablelistsms">
                    <MaterialTable
                        columns={state.columns}
                        data={props.DataMain}
                        style={{
                            borderRadius: '20px',
                            boxShadow: 'rgb(100 100 111 / 20%) 0px 7px 29px 0px'
                        }}
                        options={{
                            toolbar: true,
                            paging: true,
                            exportButton: {
                                csv: true,
                                pdf: false
                            },
                            exportAllData: true,
                            filtering: true,
                            selection: true,
                            headerStyle: {
                                backgroundColor: 'var(--itsm-bg-btn)',
                                color: '#FFF',
                                marginTop: '1%'
                            },
                            actionsColumnIndex: -1,
                        }}
                        localization={{
                            pagination: {
                                labelDisplayedRows: 'Từ {from} - đến {to} of {count}'
                            },
                            toolbar: {
                                exportCSVName: "Export danh sách chi tiết",
                                nRowsSelected: 'Đã chọn {0} dòng',
                            },
                            header: {
                                actions: ''
                            },
                            body: {
                                emptyDataSourceMessage: 'Không có dữ liệu',
                                deleteTooltip: "Xóa",
                                filterRow: {
                                    filterTooltip: 'Filter'
                                },
                                editRow: {
                                    deleteText: "Bạn đã thực sự chắc chắn muốn xóa?",
                                    cancelTooltip: "Hủy bỏ",
                                    saveTooltip: "Đồng ý",
                                },
                            },
                        }}
                        title=""
                    />
                </div>
            </div>
        );
    }
}
